import { Formik, Field } from "formik";
import * as yup from "yup";
import { ButtonPageLayout } from "../common/ButtonPageLayout";
import { Input } from "../common/Input";
import styles from "./RequestPasswordChangeForm.module.scss";
import { useMutation } from '@apollo/client';
import { FORGOT_PASSWORD } from '../../apollo/queries';
import { useNavigate } from 'react-router-dom';

interface Values {
    email: string;
}

const initialFormValues = {
    email: "",
};

const validationSchema = yup.object().shape({
    email: yup.string().email().required(),
});

export const RequestPasswordChangeForm = () => {
    const navigate = useNavigate();
    const [forgotPassword] = useMutation(FORGOT_PASSWORD, {
        onCompleted: () => {
            navigate("/login", { replace: true });
        },
        onError: () => {
            navigate("/login", { replace: true });
        }
    });

    const forgotPasswordUser = (email: string) => {
        forgotPassword({
            variables: {
                forgotPasswordInput: {
                    emailAddress: email
                },
            },
        });
    };

    return (
        <Formik
            validationSchema={validationSchema}
            initialValues={initialFormValues}
            onSubmit={(values: Values) => {
                const { email } = values;
                forgotPasswordUser(email);
            }}
        >
            {({ values, errors, touched, handleChange, handleSubmit }) => (
                <form className={styles.formContainer} onSubmit={handleSubmit}>
                    <div className={styles.emailContainer}>
                        <Field
                            name='email'
                            as={Input}
                            type='text'
                            placeholder='Email'
                            onChange={handleChange}
                            value={values.email}
                        />
                    </div>
                    <br/>
                    <ButtonPageLayout type='submit'>Change</ButtonPageLayout>
                </form>
            )}
        </Formik>
    );
};
